import React from 'react';

import { Link } from 'react-router-dom';

import classes from 'components/common/BreadCrumbItem/BreadCrumbItem.module.scss';

interface Props {
    label?: string;
    to?: string;
}

export const BreadCrumbItem = ({ label, to }: Props) => {
    const content = <div className={classes.labelWrapper}>{label ?? ''}</div>;

    return to ? (
        <Link className={`${classes.breadCrumbItem} ${to && classes.hover}`} to={to}>
            {content}
        </Link>
    ) : (
        <div className={classes.breadCrumbItem}>{content}</div>
    );
};
